module.exports = __webpack_public_path__ + "img/ab.4e7d2fc3.svg";